module.exports = __webpack_public_path__ + "img/x-circle-outline-dark-red.9a1f92d1.svg";